'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
export function LisiereLogo({ className: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <svg
      viewBox={'44 44 930 238'}
      className={e}
      role={'img'}
      aria-label={translateShowcaseNode(showcaseCopy, 'LISI\xC8RE')}
    >
      <g
        fill={'currentColor'}
        stroke={'currentColor'}
        strokeLinejoin={'round'}
        strokeWidth={0.65}
      >
        <path d={'m50.45 49.6h3.2v227h-3.2z'} strokeWidth={0.35} />
        <path
          d={
            'm105.9 95.9h48v1.95h-5.35c-8.45 0-10.75 4.05-10.75 14.55v96.35c0 10.8 2.7 13.4 15.5 13.4h8.9c21.5 0 32.55-8.8 40.7-34.3h2.3l-4.95 36.2h-94.35v-1.95h5.55c8.35 0 10.75-4 10.75-14.35v-95.6c0-10.5-2.4-14.3-10.85-14.3h-5.45z'
          }
        />
        <path
          d={
            'm256.2 95.9h46.65v1.95h-4.2c-9 0-11.15 3.95-11.15 14.85v94.65c0 11.1 2.1 14.75 11.15 14.75h4.2v1.95h-46.65v-1.95h4.35c9 0 11.2-3.7 11.2-14.75v-94.65c0-10.9-2.2-14.85-11.2-14.85h-4.35z'
          }
        />
        <path
          d={
            'm427 95.25h1.9v33.65h-2.15c-2.15-19-11.95-32.85-27.25-32.85-13.85 0-23.6 10.9-23.6 25.4 0 13.75 9.65 19.75 28.8 29 21.45 10.4 33.05 20.6 33.05 39.9 0 20.6-15.1 36.15-36.55 36.15-12.75 0-21.5-5.85-26.7-8.4-4.3-2.05-6.3 0.4-8.3 6.1h-1.9v-39.6h2.1c2.85 22.7 16.15 39.55 33.25 39.55 15.8 0 25.55-11.25 25.55-26.7 0-14.55-10-22.2-29.1-31.2-19.85-9.45-31.1-19.1-31.1-37.2 0-19.45 14-35.1 33.5-35.1 9.65 0 16.1 3.8 20.65 6.55 4.65 2.75 6.3-0.15 7.85-5.25z'
          }
        />
        <path
          d={
            'm494.5 95.9h47.3v1.95h-4.7c-8.95 0-11.1 3.95-11.1 14.85v94.65c0 11.1 2.15 14.75 11.1 14.75h4.7v1.95h-47.3v-1.95h4.55c9 0 11.2-3.7 11.2-14.75v-94.65c0-10.9-2.2-14.85-11.2-14.85h-4.55z'
          }
        />
        <path
          d={
            'm646.6 86.85-36.2-18c-3.7-1.85-4.5-5.75-2.35-8.9 2-3.1 5.65-3.2 9.1-0.35l30.05 26.45z'
          }
        />
        <path
          d={
            'm593.4 95.9h83.05l2 29.55h-2.2c-2.85-18.4-10.75-27.6-27.8-27.6h-15.25c-6.95 0-8.25 1.6-8.25 8.35v51.25h11.85c12.7 0 16.9-5.7 17.4-21.9h2.05v45.25h-2.05c-0.5-16.55-4.7-21.1-17.4-21.1h-11.85v48.95c0 11.1 2.3 13.45 15 13.45h10.5c19.7 0 28.9-7.7 35.1-30h2.15l-2.95 31.95h-91.35v-1.95h4.45c9 0 11.2-4 11.2-14.7v-94.7c0-10.85-2.2-14.85-11.2-14.85h-4.45z'
          }
        />
        <path
          d={
            'm729.8 95.9h46.95c27.95 0 41.6 12.55 41.6 33.45 0 17.2-10.9 27.85-31.4 32.5l33 48.7c5.85 8.5 10.45 11.55 20 11.55v1.95h-30.2l-38.85-60.8h-9.95v44.2c0 10.95 2.4 14.65 11.4 14.65h4.4v1.95h-46.95v-1.95h4.3c9.15 0 11.1-3.95 11.1-14.65v-94.75c0-10.85-1.95-14.85-11.1-14.85h-4.3zm31.15 65.25h9.8c19.9 0 30.25-11.25 30.25-31.05 0-20.9-10.1-32.25-26.8-32.25h-5.15c-6.75 0-8.1 1.95-8.1 9.35z'
          }
          fillRule={'evenodd'}
        />
        <path
          d={
            'm880.6 95.9h83.7l2.05 29.55h-2.25c-2.85-18.4-10.75-27.6-27.75-27.6h-15.25c-6.95 0-8.3 1.6-8.3 8.35v51.25h11.85c12.75 0 16.9-5.7 17.4-21.9h2.1v45.25h-2.1c-0.5-16.55-4.65-21.1-17.4-21.1h-11.85v48.95c0 11.1 2.3 13.45 15.05 13.45h10.5c19.65 0 28.9-7.7 35.1-30h2.1l-2.95 31.95h-92v-1.95h5.1c9 0 11.2-4 11.2-14.7v-94.7c0-10.85-2.2-14.85-11.2-14.85h-5.1z'
          }
        />
      </g>
    </svg>
  );
}
export const je = (e, t) => ({
  ...e,
  alt: t,
  ready: !1,
});
export const O = (e, t, n, r) => ({
  src: `/marketing/showcase/product/shared/brands/${e}.webp`,
  alt: t,
  width: n,
  height: r,
  ready: !0,
});
export const reference_shots_r = (e, t, n = 1280, r = 800) => ({
  light: `/marketing/showcase/product/light/${e}.webp`,
  dark: `/marketing/showcase/product/dark/${e}.webp`,
  alt: t,
  width: n,
  height: r,
});
export const reference_shots_i = {
  catalog: reference_shots_r(
    'catalog',
    'The IMAI catalogue under the composer, open on Design, Direction: create a design brief, synthesize references, explore product directions, explore colors and materials.',
    766,
    220
  ),
  composer: ((e, t) => ({
    ...e,
    darkSize: t,
  }))(
    reference_shots_r(
      'composer',
      'The IMAI composer with a picked action, Explore Product Directions, the Halden brand added with @, and four typed words: linen overshirt for SS27.',
      767,
      68
    ),
    {
      width: 767,
      height: 143,
    }
  ),
  heroThread: reference_shots_r(
    'hero-thread',
    'An IMAI conversation that finished a sneaker tech pack, with the bill of materials and component sheets open beside it.'
  ),
  techpackSketch: reference_shots_r(
    'techpack-sketch',
    'A technical sketch of a high-top sneaker from an IMAI tech pack, with callouts and a legend separating sourced details from proposals.'
  ),
  techpackSheet: reference_shots_r(
    'techpack-sheet',
    'A colorway specification spreadsheet inside an IMAI tech pack, with tabs for color standards, materials and approvals.'
  ),
  overshirtDirections: reference_shots_r(
    'overshirt-directions',
    'A short request built from the menu (Explore Product Directions, the Halden brand, \u201Clinen overshirt for SS27\u201D) and the three overshirt directions IMAI rendered in the Halden palette.',
    1280,
    1080
  ),
  overshirtCampaign: reference_shots_r(
    'overshirt-campaign',
    'The chosen Deep Fjord linen overshirt, shot by IMAI on a model on a rocky coastline in morning light.'
  ),
  brandIdentity: reference_shots_r(
    'brand-identity',
    'The Halden brand kit visual identity: a five-colour palette, logo rules and a type pairing.'
  ),
  researchPricing: reference_shots_r(
    'research-pricing',
    'An IMAI pricing scan of six linen overshirts, with a source link on every row and a recommended price range.'
  ),
  linePlannerApp: reference_shots_r(
    'line-planner-app',
    'The Halden SS27 Line Planner, an app IMAI built in the workspace: a summary strip, a status filter and eight linen styles with price, cost and margin.'
  ),
  teamChannel: reference_shots_r(
    'team-checklist',
    'A teammate asked \u201C@imai launch-week plan for the SS27 linen drop, by role\u201D in the #ss27-linen channel, and IMAI replied with a day-by-day plan for each role.'
  ),
};
export const s = reference_shots_i;
export const referenceImages = {
  lisiere: {
    pieces: [
      O(
        'lisiere-t3-northline-coat-taupe',
        'LISI\xC8RE FW27 Northline coat: a knee-length topcoat in taupe wool',
        1e3,
        1e3
      ),
      O(
        'lisiere-k1-fine-crew-chalk',
        'LISI\xC8RE FW27 Fine crew: a fine-gauge crewneck in chalk',
        1e3,
        1e3
      ),
      O(
        'lisiere-t2-balance-trouser-ink',
        'LISI\xC8RE FW27 Balance trouser: a pleated straight trouser in ink',
        1e3,
        1e3
      ),
      O(
        'lisiere-k2-atelier-cardigan-oxblood',
        'LISI\xC8RE FW27 Atelier cardigan: a crew cardigan in oxblood',
        1e3,
        1e3
      ),
      O(
        'lisiere-k3-rib-funnel-umber',
        'LISI\xC8RE FW27 Rib funnel: a heavy ribbed funnel-neck knit in umber',
        1e3,
        1e3
      ),
      O(
        'lisiere-t1-edge-jacket-ink',
        'LISI\xC8RE FW27 Edge jacket: a soft single-breasted jacket in ink',
        1e3,
        1e3
      ),
    ],
    campaign: O(
      'lisiere-campaign-launch',
      'LISI\xC8RE FW27 launch: the Northline coat over the umber funnel knit on a New York street, headed \u201CNorthline. Fall/Winter 2027\u201D',
      875,
      1100
    ),
    kit: [
      O(
        'lisiere-campaign-teaser',
        'Teaser: a close crop of the coat\u2019s finished edge and knit texture, \u201CThe finished edge.\u201D',
        875,
        1100
      ),
      O(
        'lisiere-campaign-launch',
        'Launch: the Northline coat worn over the umber funnel knit in New York',
        875,
        1100
      ),
      O(
        'lisiere-campaign-layering',
        'Layering: the coat with the chalk crew, umber funnel and oxblood cardigan, \u201CCloth, cut, finish.\u201D',
        875,
        1100
      ),
    ],
    collectionBoard: je(
      s.overshirtDirections,
      'The LISI\xC8RE FW27 collection in IMAI Studio'
    ),
    linePlan: je(s.linePlannerApp, 'The LISI\xC8RE FW27 line plan'),
    buyerPackage: je(s.techpackSheet, 'The LISI\xC8RE FW27 buyer package'),
    brandKit: je(s.brandIdentity, 'The LISI\xC8RE brand kit'),
  },
  orvieto: {
    hero: O(
      'orvieto-box-tote',
      'Casa Orvieto FW27 box tote in cognac leather, rendered by IMAI',
      1e3,
      1e3
    ),
    directions: [
      O(
        'orvieto-box-tote',
        'Direction 1: a rigid box tote in cognac with flat edge-painted handles and no visible hardware',
        1e3,
        1e3
      ),
      O(
        'orvieto-trapezoid-tote',
        'Direction 2: a trapezoid tote in ink brown-black with rolled handles and a brass-tone post closure',
        1e3,
        1e3
      ),
      O(
        'orvieto-arc-tote',
        'Direction 3: an arc tote in olive pebbled calf with a curved shoulder handle and a matte metal tab',
        1e3,
        1e3
      ),
    ],
    techPack: je(s.techpackSketch, 'Casa Orvieto tote tech pack'),
    costing: je(s.techpackSheet, 'Casa Orvieto sourcing and costing'),
    brandKit: je(s.brandIdentity, 'The Casa Orvieto brand kit'),
  },
  aubrac: {
    campaign: O(
      'aubrac-launch',
      'Maison Aubrac FW27 launch hero: the sculpted umber-black wool coat dress in a limestone room',
      876,
      1100
    ),
    kit: [
      O(
        'aubrac-teaser',
        'Teaser: a back view of the coat dress silhouette in a limestone room',
        876,
        1100
      ),
      O(
        'aubrac-launch',
        'Launch: a full-length frontal hero showing the curved shoulder-to-waist seam and covered buttons',
        876,
        1100
      ),
      O(
        'aubrac-detail',
        'Last call: a close-up of the hand-finished hem and a covered button',
        876,
        1100
      ),
    ],
    listing: O(
      'aubrac-listing-front',
      'Maison Aubrac FW27 coat dress, front view on a white studio background',
      1e3,
      1e3
    ),
    listings: [
      O('aubrac-listing-front', 'Front view on white', 1e3, 1e3),
      O(
        'aubrac-listing-back',
        'Back view: closed back with two curved seams',
        1e3,
        1e3
      ),
      O(
        'aubrac-listing-side',
        'Side view: covered buttons in profile',
        1e3,
        1e3
      ),
      O(
        'aubrac-listing-seam',
        'Seam detail: the curved shoulder-to-waist seam',
        1e3,
        1e3
      ),
    ],
    pdp: [
      O(
        'aubrac-pdp-shape',
        'Shaped by seam: one curved seam, shoulder to waist',
        876,
        1100
      ),
      O(
        'aubrac-pdp-finish',
        'Finished by hand: hand-finished hem, covered buttons',
        876,
        1100
      ),
      O(
        'aubrac-pdp-cloth',
        'Double-faced wool: umber-black, dense and matte',
        876,
        1100
      ),
    ],
    brandKit: je(s.brandIdentity, 'The Maison Aubrac brand kit'),
  },
  mercer: {
    logo: O(
      'mercer-logo',
      'The MERCER & VALE wordmark and M&V monogram IMAI drew for the brand kit',
      1200,
      675
    ),
    images: [
      O(
        'mercer-loft',
        'Mercer & Vale womenswear in a SoHo loft with home pieces',
        876,
        1100
      ),
      O(
        'mercer-stoneware',
        'Mercer & Vale home line: stoneware bowls on linen',
        876,
        1100
      ),
      O(
        'mercer-street',
        'Mercer & Vale womenswear on a SoHo street',
        876,
        1100
      ),
    ],
    finance: je(
      s.researchPricing,
      'A Mercer & Vale wholesale order evaluation'
    ),
    yourImai: je(s.teamChannel, 'Your IMAI chat for Mercer & Vale'),
    app: je(s.linePlannerApp, 'A Mercer & Vale operations app'),
    brandKit: je(s.brandIdentity, 'The Mercer & Vale brand kit'),
  },
};
export const Me = {
  lisiere: ['#F2EEE6', '#D8CFC0', '#8B7E6E', '#3A342D', '#1C1A17'],
  orvieto: ['#F3EDE3', '#B9A98F', '#8A4B2D', '#3E4A3D', '#1F1A17'],
  aubrac: ['#F3EEE6', '#D8CDBE', '#8C7B6B', '#7A2E2A', '#14110F'],
  mercer: ['#F4EFE7', '#CBBFAE', '#B5654A', '#3F4A3C', '#1C1B19'],
};
